<template>
    <div class="main-block">
        <div id="editor-gen" v-html="content" style="padding:0;"></div>
        <div class="form-area" v-if="isNeedSubmit">
            <div class="form-row">
                <span class="row-title">姓名</span>
                <span class="row-colon">:</span>
                <input v-model="name" type="text"  @blur="fixScroll" class="long-inp" maxlength="10">
            </div>
            <div class="form-row">
                <span class="row-title">手机号</span>
                <span class="row-colon">:</span>
                <input v-model="cellphone" type="text" @blur="fixScroll" class="long-inp" maxlength="11">
            </div>
            <div class="submit-row">
                <span class="btn-block" :style="{color: bgColor}">提交</span>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/views/Layout.vue';

export default {
    name: 'previewWechatProduct',
    components: {
        Layout,
    },
    data() {
        return {
            productName: '',
            content: '',
            name: '',
            cellphone: '',
            bgColor: '',
            isNeedSubmit: false,
        };
    },
    mounted() {
        const self = this;
        // const { productId } = this.$route.query;
        document.body.style.background = '#3DBBED';
        const getMessage = (event) => {
            console.log(event);
            if (!event.data.wechatProductPage) return;
            const result = event.data;
        // ajax.get('/web/wx/product_detail.json', {
        //     id: productId,
        // }).then((result) => {
            self.content = result.data.productContent;
            self.productName = result.data.productName;
            self.isNeedSubmit = result.data.productType === 'submit';
            document.body.style.background = result.data.backgroundColor;
            window.removeEventListener('message', getMessage);
        // }).catch(() => {});
        };
        window.addEventListener('message', getMessage, false);
        if (window.opener) {
            window.opener.postMessage('wechatProductReady');
        }
    },
    methods: {
        fixScroll(event) {
            const top = event.target.getBoundingClientRect().top + document.documentElement.scrollTop;
            document.documentElement.scrollTop = top;
        },
    },
};
</script>
<style lang="less" scope>
    .form-row {
        position: relative;
        margin: 18px 78px 0 106px;
        height: 30px;
        line-height: 20px;
        border-bottom: 1px #fff solid;
        .long-inp {
            display: inline-block;
            width: 100%;
            height: 30px;
            line-height: 30px;
            border: 0;
            color: #fff;
            background: transparent;
            text-indent: 10px;
        }
        .row-title {
            position: absolute;
            top: 0;
            left: -56px;
            width: 45px;
            height: 30px;
            line-height: 30px;
            text-align: justify;
            text-align-last: justify;
            color: #fff;
        }
        .row-colon {
            position: absolute;
            top: 0;
            left: -10px;
            height: 30px;
            line-height: 30px;
            text-align: left;
            color: #fff;
        }
    }
    .submit-row {
        text-align: center;
        margin-top: 28px;
        padding-bottom: 20px;
        .btn-block {
            display:inline-block;
            background-color: #fff;
            color: #3DBBED;
            width: 164px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 16px;
            letter-spacing: 1px;
        }
    }
</style>
